<div class="ticket-card">
  <div *ngIf="serviceName" class="info-service">
    <p class="track-number">{{ serviceName }}</p>
    <p class="waiting-info">{{ 'general.pages.track.details.service' | translate | uppercase }}</p>
  </div>
  <div *ngIf="resourceName" class="info-resource">
    <p class="track-number">{{ resourceName | uppercase }}</p>
    <p class="waiting-info">{{ 'general.pages.track.details.professional' | translate | uppercase }}</p>
  </div>
  <div *ngIf="showQueueInfo" class="queue-info">
    <div class="info-position">
      <p class="track-number">{{ ticketPosition }}</p>
      <p class="waiting-info">{{ 'general.components.trackInformation.position' | translate }}</p>
    </div>
    <div *ngIf="!disablePrevision" class="info-prevision">
      <p class="track-number">{{ prevision }}</p>
      <p class="waiting-info">{{ 'general.components.trackInformation.forecast' | translate }}</p>
    </div>
  </div>
  <div class="info-code">
    <p class="track-number">{{ ticketCode }}</p>
    <p class="waiting-info">{{ 'general.pages.track.details.ticket' | translate }}</p>
  </div>
</div>
